export enum CompletionFormatEnum {
    EMAIL = 'EMAIL',
    // DEPRECATED
    PRESS_RELEASE = 'PRESS_RELEASE',
    PRESS_RELEASE_NEWSWIRE = 'PRESS_RELEASE_NEWSWIRE',
    PRESS_RELEASE_DISTRIBUTION  = 'PRESS_RELEASE_DISTRIBUTION',
}
